import { render, staticRenderFns } from "./distributorSalesman.vue?vue&type=template&id=128f4c53&scoped=true&"
import script from "./distributorSalesman.vue?vue&type=script&lang=js&"
export * from "./distributorSalesman.vue?vue&type=script&lang=js&"
import style0 from "./distributorSalesman.vue?vue&type=style&index=0&id=128f4c53&lang=scss&scoped=true&"
import style1 from "./distributorSalesman.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "128f4c53",
  null
  
)

export default component.exports